import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Button, Col, Row, Skeleton, Typography } from "antd";
import PageContainer from "../../../components/PageContainer";
import withWikiWrapper from "../WikiWrapper";
import { Messages } from "../../../components/Messages";
import WikiArticleLarge from "../WikiArticleLarge";
import ContentSearch from "../../blog/components/ContentSearch";
import { getCategoryService, getContentPerCategoryService } from "../wiki.api";
import { LeftOutlined } from "@ant-design/icons";

const { Paragraph } = Typography;

const ITEM_PER_PAGE = 3000;

const WikiPerCategory = (props) => {
  const { title } = props;

  const { categoryId } = useParams();
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [page, setPage] = useState(searchParams.get("page") || 0);
  const [category, setCategory] = useState({
    description: "",
    id: "1",
    imagePath: "",
    parentId: "",
    title: "",
    type: "Wiki",
  });
  const [contents, setContents] = useState([]);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);

    getCategoryService(categoryId)
      .then((res) => {
        setCategory(res.data);

        getContentPerCategoryService({
          title,
          categoryId,
          pageNumber: page,
          pageSize: ITEM_PER_PAGE,
          sort: "ASC",
          sortKey: "createdDate",
        })
          .then((res) => {
            setLoading(false);
            if (res.data.hasOwnProperty("content")) {
              setContents(res.data.content);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        setContents([]);
        setLoading(false);
        console.error(err);
      });
  }, [title, categoryId, page]);

  const onBack = () => {
    history.goBack();
  };

  return (
    <PageContainer
      classNames="wrap-wiki"
      headerProps={{
        tall: true,
        right: <Messages />,
        content: contents?.[0]?.categories?.[0]?.title
          ? contents?.[0]?.categories?.[0]?.title
          : "",
        children: (
          <ContentSearch
            showFilterForm={false}
            allowClear={true}
            inputName="fullSearch"
          />
        ),
        className: "wrap-wiki-header",
        left: (
          <Button onClick={onBack} type="text">
            <LeftOutlined className="back-icon" />
          </Button>
        ),
      }}
    >
      <Row>
        <Col span={24}>
          <div className="legal-vocabulary">
            <Skeleton active={true} loading={loading}>
              <div className="header">
                <Paragraph ellipsis className="title">
                  {category.title}
                </Paragraph>
                <Paragraph ellipsis className="text">
                  {category.description}
                </Paragraph>
              </div>
              <div className="word-wrapper">
                {contents && contents.length
                  ? contents.map((content, i) => (
                      <div>
                        <WikiArticleLarge
                          key={content.id}
                          Id={content.id}
                          Number={i + 1}
                          Title={content.title.fields[0]}
                          VisitCount={content.visitedCount}
                          Description={content.summary.fields[0]}
                        />
                        
                      </div>
                    ))
                  : "نتیجه‌ای یافت نشد"}
              </div>
            </Skeleton>
          </div>
        </Col>
      </Row>
    </PageContainer>
  );
};

export default withWikiWrapper(WikiPerCategory);
